import type { NavSection } from '@pazportal/ui';

// Ink, matching the customer portal and admin (paznetworks.com header).
export const PORTAL_COLOR = '#1F1E26';
export const PORTAL_NAME = 'PazNetworks, Inc.';
export const PORTAL_SUBTITLE = 'Estimator';

export const navSections: NavSection[] = [
  {
    label: 'Estimates',
    items: [
      { label: 'Dashboard', href: '/dashboard' },
      { label: 'New Estimate', href: '/estimates/new' },
      { label: 'Proposals', href: '/proposals' },
    ],
  },
  {
    label: 'Communication',
    items: [
      { label: 'Mailbox', href: '/mailbox' },
    ],
  },
  {
    label: 'Config',
    items: [
      { label: 'Settings', href: '/settings' },
    ],
  },
];
